import { Image } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';

import { Token } from '../model';
import type { TokenRegister } from './types';

export const getWBTCToken: TokenRegister = (desiredNetwork, sdks) => {
  return {
    type: Token.WBTC,
    symbol: 'WBTC',
    addressL1: sdks.L1.getContractAddress('WBTC'),
    addressL2: sdks.L2.getContractAddress('WBTC'),
    addressCronosEvm: '',
    decimals: 8,
    displayDecimals: 3,
    Icon: (props) => (
      <Image
        src={getAssetUrl('/tokens/btc.svg')}
        boxSize="24px"
        // eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
        alt="WBTC"
        {...props}
      />
    ),
  };
};
